import React, { useEffect } from 'react';
import Hero from './Components/Hero';
import './styles/animations.css';
import CoffeeWorld from './Components/CoffeeWorld.jsx'
import Contact from './Components/Contact.jsx'
import ProductPage from './Components/ProductPage.jsx'
import Info from './Components/FAQ.jsx'
import Demo from './Components/ProductPage.jsx'
import PrivacyPolicy from './Components/PrivacyPolicy.jsx';
import TermsAndConditions from './Components/TermsAndConditions.jsx';
import Disclaimer from './Components/Disclaimer.jsx';
import CancellationPolicy from './Components/CancellationPolicy.jsx';
import {BrowserRouter, Routes, Route} from 'react-router-dom'



function App() {
  useEffect(() => {
    // Add Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Source+Sans+Pro:wght@400;600&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  
    
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <div style={{
      width: '100%',
      overflowX: 'hidden',
    }}>
    <BrowserRouter>
    <Routes>
      <Route path='/CoffeeWorld' element={<CoffeeWorld />}/>
      <Route path='/Contact' element={<Contact />}/>
      <Route path='/demo' element={<ProductPage />}/>
      <Route path='/FAQ' element={<Info />}/>
      <Route path='/Product' element={<Demo />}/>
      <Route path='/' element={<Hero />}/>
      <Route path='/PrivacyPolicy' element={<PrivacyPolicy />}/>
      <Route path='/Terms & Conditions' element={<TermsAndConditions />}/>
      <Route path='/Disclaimer' element={<Disclaimer />}/>
      <Route path='/CancellationPolicy' element={<CancellationPolicy />}/>     
    </Routes>
    </BrowserRouter>
    </div>
    </>
  );
}

export default App;